module.exports = __webpack_public_path__ + "img/ate-marina.d3370cdf.jpg";